interface response {
    code: number;
    message: string;
  }
  
export function obtainTeamPrize (startDate?: string): Promise<response> {
  if (startDate) {
    return request({
      url: '/gamecard/v2/share/assistance/obtainTeamPrize',
      type: 'POST',
      data: {
        startDate
      }
    });
  } else {
    return request({
      url: '/gamecard/v2/share/assistance/obtainTeamPrize',
      type: 'POST'
    });
  }

}
  